const Checkmark = (): JSX.Element => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.20361 8.37468L6.15777 11.2033L6.13869 11.185L12.8036 4.80331'
      stroke='#14984C'
      strokeWidth='1.40492'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default Checkmark;
